import { render, staticRenderFns } from "./UserSecurityLocks.vue?vue&type=template&id=cf1b156c&scoped=true&"
import script from "./UserSecurityLocks.vue?vue&type=script&lang=js&"
export * from "./UserSecurityLocks.vue?vue&type=script&lang=js&"
import style0 from "./UserSecurityLocks.vue?vue&type=style&index=0&id=cf1b156c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1b156c",
  null
  
)

export default component.exports